(function () {
  var SJ = 'saint-john';
  var LE = 'lethbridge';

  function selected() {
    try { return localStorage.getItem('selected_location') || ''; } catch (e) { return ''; }
  }
  function locationTag() {
    var params = new URLSearchParams(location.search);
    var carried = params.get('dbs_location');
    if (carried === SJ || carried === LE) return carried;

    if (/\/saint-john\/?$/.test(location.pathname)) return SJ;
    if (/\/lethbridge\/?$/.test(location.pathname)) return LE;

    var v = String(selected());
    if (/75896881351|saint\s*john/i.test(v)) return SJ;
    if (/75900977351|lethbridge/i.test(v)) return LE;
    return '';
  }
  function isCollectionPage() {
    return /^\/collections\/[^\/]+\/?$/.test(location.pathname) ||
           /^\/collections\/[^\/]+\/(saint-john|lethbridge)\/?$/.test(location.pathname);
  }
  function filterAmoreCards(scope) {
    var tag = locationTag();
    if (!tag) return;

    var cards = (scope || document).querySelectorAll('product-block[data-dbs-amore="true"]');
    cards.forEach(function (card) {
      var stocked = tag === SJ
        ? card.dataset.dbsSaintJohn === 'true'
        : card.dataset.dbsLethbridge === 'true';

      card.hidden = !stocked;
      card.setAttribute('aria-hidden', stocked ? 'false' : 'true');
    });
  }

  function redirectAmoreProduct() {
    if (!/^\/products\//.test(location.pathname) && !/^\/collections\/[^\/]+\/products\//.test(location.pathname)) return;

    var form = document.querySelector('product-form[data-dbs-amore="true"]');
    if (!form) return;

    var tag = locationTag();
    if (!tag) return;

    var stocked = tag === SJ
      ? form.dataset.dbsSaintJohn === 'true'
      : form.dataset.dbsLethbridge === 'true';

    if (stocked) return;

    location.replace('/collections/amore/' + tag);
  }

  function redirectCollection() {
    if (!isCollectionPage()) return;
    var tag = locationTag();
    if (!tag) return;

    var parts = location.pathname.split('/').filter(Boolean);
    if (parts[0] !== 'collections' || !parts[1]) return;
    var currentTag = parts[2] || '';
    if (currentTag === tag) return;

    var next = '/collections/' + parts[1] + '/' + tag + location.search;
    location.replace(next);
  }

  function runLocationRouting() {
    filterAmoreCards(document);
    redirectAmoreProduct();
    redirectCollection();
  }

  function scheduleAmoreRedirect() {
    setTimeout(redirectAmoreProduct, 25);
    setTimeout(redirectAmoreProduct, 150);
    setTimeout(redirectAmoreProduct, 500);
  }

  document.addEventListener('on:variant:change', scheduleAmoreRedirect);
  document.addEventListener('on:quickbuy:after-open', scheduleAmoreRedirect);
  document.addEventListener('shopify:section:load', scheduleAmoreRedirect);
  document.addEventListener('on:variant:before-replace-element', scheduleAmoreRedirect);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runLocationRouting);
  } else {
    runLocationRouting();
  }

  var cardObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var added = mutations[i].addedNodes || [];
      for (var j = 0; j < added.length; j += 1) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && node.matches('product-block')) ||
          (node.querySelector && node.querySelector('product-block[data-dbs-amore="true"]'))
        ) {
          filterAmoreCards(document);
          scheduleAmoreRedirect();
          return;
        }
      }
    }
  });
  cardObserver.observe(document.body, { childList: true, subtree: true });

  try {
    var original = Storage.prototype.setItem;
    if (!window.__dbsCollectionLocationPatched) {
      window.__dbsCollectionLocationPatched = true;
      Storage.prototype.setItem = function (key, value) {
        original.apply(this, arguments);
        if (key === 'selected_location') setTimeout(runLocationRouting, 20);
      };
    }
  } catch (e) {}
})();